module.exports = __webpack_public_path__ + "media/images/mamari/wowma/header-logo-69045b72bb31d1e55bc3b23bbe523d81.png";